import { createContext, useContext, useState } from 'react';

const LayoutContext = createContext(null);

export const LayoutProvider = ({children}: any) => {
  const [layoutState, setLayoutState] = useState({
    accounts: [],
  });

  const updateGlobalState = (newState: any) => {
    setLayoutState((prevGlobalState) => ({ ...prevGlobalState, ...newState }));
  };

  return (
      <LayoutContext.Provider value={{ layoutState, setLayoutState }}>
        {children}
      </LayoutContext.Provider>
  );
};

export const useLayoutContext = () => {
  return useContext(LayoutContext);
};